export type ChartView = "none" | "marketScience" | "gartner";

export const CHART_VIEW_TITLES: Record<Exclude<ChartView, "none">, string> = {
  marketScience: "Рыночные и научные метрики",
  gartner: "Жизненный цикл технологии",
};

export const isActiveChartView = (
  chartView: ChartView,
  activeTab: string,
  cpuStep: number
): chartView is Exclude<ChartView, "none"> => {
  if (chartView === "none") {
    return false;
  }

  if (chartView === "marketScience") {
    return activeTab === "CPU" && cpuStep >= 1;
  }

  return activeTab === "CPU" && cpuStep >= 1;
};
